import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorker from './serviceWorker';
import img10 from './img10.png';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <div>
    <img className="img10" src={img10} />
  </div>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
